import React from 'react'
import CmsTextEditor from 'cms/CmsTextEditor'

const TextEditor = ({
  content: {
    html,
  },
  style,
  settings,
  currentLang,
  renderElement,
}) => (
  renderElement(
    CmsTextEditor,
    {
      style,
      html: html[currentLang],
      ...settings,
    },
  )
)

TextEditor.propTypes = {}
TextEditor.defaultProps = {}

export default TextEditor



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/textEditor/TextEditor.js